import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Eyebrow } from "@/components/Reveal";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Admin — THE GOOD GRID";
    if (localStorage.getItem("tgg_admin_token")) navigate("/admin", { replace: true });
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("tgg_admin_token", data.token);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="bg-charcoal text-ivory min-h-screen flex items-center justify-center px-4">
      <form onSubmit={submit} className="w-full max-w-md border border-white/10 bg-[#161616] p-8 sm:p-10">
        <Eyebrow>THE GOOD GRID — CMS</Eyebrow>
        <h1 className="font-serif text-3xl mt-4 mb-8">Admin Sign In</h1>
        <label htmlFor="admin-email" className="block text-[10px] font-mono uppercase tracking-[0.25em] text-ivory/50 mb-2">Email</label>
        <input
          id="admin-email"
          data-testid="admin-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="w-full bg-transparent border border-white/15 focus:border-champagne text-ivory text-sm px-4 py-3.5 outline-none mb-5 transition-colors"
        />
        <label htmlFor="admin-password" className="block text-[10px] font-mono uppercase tracking-[0.25em] text-ivory/50 mb-2">Password</label>
        <input
          id="admin-password"
          data-testid="admin-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="w-full bg-transparent border border-white/15 focus:border-champagne text-ivory text-sm px-4 py-3.5 outline-none mb-6 transition-colors"
        />
        {error && <p data-testid="admin-login-error" className="text-sm text-red-400 mb-4">{error}</p>}
        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loading}
          className="w-full bg-champagne text-charcoal text-[11px] font-mono uppercase tracking-[0.22em] py-4 hover:bg-champagne-light transition-colors disabled:opacity-60"
        >
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
